import { styled } from '@slal/ui';
import { Article as SUIArticle } from '@slal/ui/typography';

export const Article = styled(SUIArticle)`
    display: flex;
    flex-direction: column;
    gap: 8px;
    p {
        margin-bottom: 0;
    }
`;
